export default function HomePage() {
    return (
        <div>Home</div>
    );
}